export const BenefitsGrayPay = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 43.099 36">
		<g id="Grupo_1969" data-name="Grupo 1969" transform="translate(-19.75 -1444.666)">
			<g id="Grupo_1968" data-name="Grupo 1968" transform="translate(20 1444.915)">
				<g id="Grupo_35" data-name="Grupo 35" transform="translate(0 0)">
					<g id="Grupo_34" data-name="Grupo 34" transform="translate(0 0)">
						<path
							id="Trazado_32"
							data-name="Trazado 32"
							d="M190.009-376.978H150.96a1.754,1.754,0,0,0-1.775,1.731v20.081a1.754,1.754,0,0,0,1.775,1.731h39.049a1.754,1.754,0,0,0,1.775-1.731v-20.081A1.754,1.754,0,0,0,190.009-376.978Zm-23.092,14.792a1.754,1.754,0,0,0-1.775,1.731,1.754,1.754,0,0,0,1.775,1.731h1.793v1.826H152.735v-16.619H168.71v1.835h-.027a4.212,4.212,0,0,0-4.3,4.1,4.212,4.212,0,0,0,4.3,4.1H172.3a.712.712,0,0,1,.746.649.709.709,0,0,1-.746.641h-5.378Zm21.317,5.289H172.26v-1.826h.035A4.259,4.259,0,0,0,176.5-362a3.9,3.9,0,0,0,.088-.826,3.919,3.919,0,0,0-.088-.827,4.261,4.261,0,0,0-4.208-3.284h-3.612a.714.714,0,0,1-.754-.641.705.705,0,0,1,.754-.641h5.369a1.754,1.754,0,0,0,1.775-1.731,1.754,1.754,0,0,0-1.775-1.731H172.26v-1.835h15.975Z"
							transform="translate(-149.185 376.978)"
							fill="#2C2C2C"
							stroke="#fff"
							stroke-width="0.5"
						/>
					</g>
				</g>
				<g id="Grupo_37" data-name="Grupo 37" transform="translate(0 25.309)">
					<g id="Grupo_36" data-name="Grupo 36" transform="translate(0 0)">
						<path
							id="Trazado_33"
							data-name="Trazado 33"
							d="M190.009-139.9H150.96c-.98,0-1.775,1.065-1.775,2.378s.8,2.378,1.775,2.378h39.049c.98,0,1.775-1.065,1.775-2.378S190.989-139.9,190.009-139.9Z"
							transform="translate(-149.185 139.898)"
							fill="#2C2C2C"
							stroke="#fff"
							stroke-width="0.5"
						/>
					</g>
				</g>
				<g id="Grupo_39" data-name="Grupo 39" transform="translate(0 30.743)">
					<g id="Grupo_38" data-name="Grupo 38" transform="translate(0 0)">
						<path
							id="Trazado_34"
							data-name="Trazado 34"
							d="M190.009-88.978H150.96c-.98,0-1.775,1.065-1.775,2.378s.8,2.378,1.775,2.378h39.049c.98,0,1.775-1.065,1.775-2.378S190.989-88.978,190.009-88.978Z"
							transform="translate(-149.185 88.978)"
							fill="#2C2C2C"
							stroke="#fff"
							stroke-width="0.5"
						/>
					</g>
				</g>
			</g>
		</g>
	</svg>
);
